
import Radar from "../../../assets/filled/Radar.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RadarIcon({ className, dataTestid = "RadarIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Radar data-testid={dataTestid} className={classes} {...rest} />
  );
}
